module.exports = __webpack_public_path__ + "static/media/Trial2_wordchain.8e9be24c.mp3";